// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header"; 
import MainNav from "./components/MainNav"; 
import HeroSection from "./components/HeroSection"; 
import CategorySection from "./components/CategorySection";
import WorldNewsSection from "./components/WorldNewsSection";
import VideoSection from "./components/VideoSection";
import LatestNewsSection from "./components/LatestNewsSection";
import Footer from "./components/Footer";
import ArticlePage from "./components/ArticlePage";
import AdminLogin from "./components/admin/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./components/admin/Dashboard";
import PostForm from "./components/admin/PostForm";
import Comments from "./components/admin/Comments";
import Newspaper from "./components/admin/Newspaper";
import MarketOverview from "./components/MarketOverview";
import Charsooq from "./components/Charsooq";
import PrivateRoute from "./components/admin/PrivateRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import './components/admin/Admin.css';  

function App() {
  return (
    <Router>
      <div>
        <Routes>
          {/* Non-Admin Routes: Header, MainNav, and Footer */}
          <Route path="/" element={
            <>
              <Header />
              <MainNav />
              <HeroSection />
              <CategorySection />
              <WorldNewsSection />
              
    <MarketOverview />
  
              <VideoSection />
              <LatestNewsSection />
              <Footer />
            </>
          } />

          {/* Article Page */}
          <Route path="/article/:slug" element={
            <>
              <Header />
              <MainNav />
              <ArticlePage />
              <Footer />
            </>
          } />

          {/* روزنامه چارسوق Page */}
           <Route path="/charsooq" element={
            <>
              <Header />
              <MainNav />
              <Charsooq />  {/* Render Charsooq component */}
              <Footer />
            </>
          } />

          {/* Admin Login Page */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Protected Admin Routes */}
          <Route path="/admin" element={
            <PrivateRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/posts/new" element={
            <PrivateRoute>
              <AdminLayout>
                <PostForm />
              </AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/posts/:id/edit" element={
            <PrivateRoute>
              <AdminLayout>
                <PostForm />
              </AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/comments" element={
            <PrivateRoute>
              <AdminLayout>
                <Comments />
              </AdminLayout>
            </PrivateRoute>
          } />
           {/* Admin Newspaper Route */}
           <Route path="/admin/newspaper" element={
            <PrivateRoute>
              <AdminLayout>
                <Newspaper />  {/* Render Newspaper component */}
              </AdminLayout>
            </PrivateRoute>
          } />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
